import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=08cc6e86&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=08cc6e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc6e86",
  null
  
)

export default component.exports